/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".associated-airports__airport[_ngcontent-%COMP%]{display:flex;padding:15px 30px;font-size:15px}.associated-airports__airport-name[_ngcontent-%COMP%]{flex:1 1 auto;color:#383838;font-weight:600}li[_ngcontent-%COMP%]{line-height:24px}#add_btn[_ngcontent-%COMP%]{background-color:#00b6ac}"];
export { styles as styles };
